import type {TypedUseSelectorHook} from 'react-redux'
import {
    useDispatch,
    useSelector
} from 'react-redux'

import type {AppDispatch, RootState} from '../store/index'


// Use throughout your app instead of plain `useDispatch` and `useSelector`.
// FNP-325: AppDispatch is composed in store/index.ts to include ThunkDispatch
// so that `dispatch(myAsyncThunk(...))` type-checks here.
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
